<template>
    <Tabs :customer="customer" />

    <DCard padding>
        <DRow
            class="mb-3"
            align-vertical="end"
        >
            <DCol
                sm="2"
                class="pt-1"
            >
                <DInput
                    id="messenger_date_from"
                    v-model="filters.date_from"
                    type="date"
                    :label="__('customers.communications.filters.date_from')"
                    class="mb-0"
                />
            </DCol>
            <DCol
                sm="2"
                class="pt-1"
            >
                <DInput
                    id="messenger_date_to"
                    v-model="filters.date_to"
                    type="date"
                    :label="__('customers.communications.filters.date_to')"
                    class="mb-0"
                />
            </DCol>
            <DCol
                sm="3"
                class="d-flex gap-2"
            >
                <DButton
                    :label="__('customers.communications.filters.filter')"
                    @click="changePage"
                />
                <DButton
                    icon="filter-off"
                    :label="__('customers.communications.filters.reset_filters')"
                    @click="resetFilters"
                />
            </DCol>
        </DRow>
        <DRow>
            <DCol>
                <DTable
                    :items="data.items"
                    :fields="fields"
                >
                    <template #created_at="{item}">
                        <td>
                            {{ setDateFormat(item.created_at) }}
                        </td>
                    </template>
                </DTable>
            </DCol>
        </DRow>
        <DFabs>
            <s-s-o-fab
                :customer="customer"
                @open-modal="showCreateCloudpitCustomerModal = true"
                @close-modal="showCreateCloudpitCustomerModal = false"
            />
        </DFabs>

        <DPagination
            v-if="data.pagination.last_page > 1"
            class="pb-2"
            :active-page="data.pagination.current_page"
            :pages="data.pagination.last_page"
            align="center"
            @update:activePage="changePage"
        />

        <CreateCloudPitCustomerModal
            :customer="customer"
            :show-modal="showCreateCloudpitCustomerModal"
            @close-modal="showCreateCloudpitCustomerModal = false"
        />
    </DCard>
</template>

<script>
import App from '~@/App.vue'
import CustomerBase from '~@/Pages/Customers/Base'
import SSOFab from '~@/Components/Customers/SSOFab'
import CreateCloudPitCustomerModal from '~@/Components/Customers/CreateCloudPitCustomerModal'
import Tabs from '~@/Pages/Customers/EmailArchives/Tabs'
import { reactive, ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'

export default {
    layout: [App, CustomerBase]
}
</script>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => { return {} }
    },
    customer: {
        type: Object,
        default: () => { return {} }
    },
    filtersData: {
        type: Object,
        default: () => { return {} }
    }
})

const fields = [
    { key: 'template_name', label: __('customers.communications.template') },
    { key: 'subject', label: __('customers.communications.subject') },
    { key: 'to', label: __('customers.communications.recipients') },
    { key: 'created_at', label: __('customers.communications.created') },
    { key: 'actions', label: '' }
]

const showCreateCloudpitCustomerModal = ref(false)
const filters = reactive(props.filters_data ?? {})

function changePage (page = 1) {
    const queryParameters = Object.fromEntries(Object.entries(filters).filter(([_, v]) => v))

    if (page > 1) {
        queryParameters.page = page
    }

    router.get(route('customers.customers.communications.messenger.index', { customer: props.customer.id }), queryParameters)
}

function resetFilters () {
    filters.date_from = null
    filters.date_to = null
    changePage(1)
}
</script>
